
import permission from './js/permission';


import debounce  from './js/debounce';

const directives = {
    permission,
    debounce ,
  }
  
  export default {
    install(Vue){
      Object.keys(directives).forEach(key=>{
        Vue.directive(key, directives[key])
      })
    }
  }


// WEBPACK FOOTER //
// ./src/directives/index.js